import React from "react";
import { AuthMethod } from "../schemas/auth";

interface AuthMethodCardProps {
  method: AuthMethod;
  onSelect: (method: AuthMethod) => void;
  disabled?: boolean;
}

export default function AuthMethodCard({
  method,
  onSelect,
  disabled = false,
}: AuthMethodCardProps) {
  const displayName =
    method.type === "password" ? "Password" : method.idp_name ?? "SSO";

  return (
    <button
      type="button"
      className="auth-method-card card w-100 text-start border mb-3"
      onClick={() => onSelect(method)}
      disabled={disabled}
      aria-label={`Sign in with ${displayName}`}
    >
      <div className="card-body d-flex align-items-center gap-3 py-3 px-4">
        <div className="text-muted flex-shrink-0">
          {method.type === "password" ? (
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
            </svg>
          ) : (
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
          )}
        </div>
        <div className="fw-semibold text-dark">{displayName}</div>
        <div className="ms-auto text-muted">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </div>
      </div>
    </button>
  );
}
